import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

const INPUT = "bg-[#050505] border border-white/10 rounded px-2.5 py-1.5 text-xs font-mono focus:outline-none focus:border-white/30 transition-colors";

export default function AddServerForm({ onDone, onCancel }) {
    const [label, setLabel] = useState("");
    const [region, setRegion] = useState("");
    const [channel, setChannel] = useState("prod");
    const [busy, setBusy] = useState(false);
    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try { await api.post("/admin/mongo-mcp/servers", { label, region, channel }); toast.success(`${label} added`); onDone(); }
        catch (err) { toast.error(formatApiErrorDetail(err?.response?.data?.detail)); }
        finally { setBusy(false); }
    };
    return (
        <form onSubmit={submit} className="mb-3 rounded-md border border-white/10 bg-[#0a0a0a] p-3 flex flex-wrap items-end gap-2.5" data-testid="mongo-server-add-form">
            <input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Name, e.g. UK-prod" className={`${INPUT} w-44`} data-testid="mongo-server-add-label" />
            <input value={region} onChange={(e) => setRegion(e.target.value)} placeholder="Region, e.g. uk" className={`${INPUT} w-32`} data-testid="mongo-server-add-region" />
            <select value={channel} onChange={(e) => setChannel(e.target.value)} className={INPUT} data-testid="mongo-server-add-channel">
                {["dev", "stage", "prod"].map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
            <button type="submit" disabled={busy || !label.trim() || !region.trim()} className="px-3 py-1.5 text-xs rounded-md bg-white text-black disabled:opacity-50"
                data-testid="mongo-server-add-submit">{busy ? "Adding…" : "Add"}</button>
            <button type="button" onClick={onCancel} className="px-3 py-1.5 text-xs rounded-md border border-white/10 hover:bg-white/5" data-testid="mongo-server-add-cancel">Cancel</button>
        </form>
    );
}
